package com.milta.core.localization.translations.it

import com.milta.core.localization.RouteStrings
import com.milta.core.localization.RouteStringsCoreImpl
import com.milta.core.localization.RouteStringsExtraImpl

internal val Route = RouteStrings(
    core = RouteStringsCoreImpl(
    manualDeliveryTitle = "Nuova consegna",
    manualDeliverySubtitle = "Aggiungi una consegna al percorso",
    recipientNameLabel = "Nome del destinatario",
    addressLabel = "Indirizzo",
    phoneNumberLabel = "Telefono",
    deliveryTimeLimitLabel = "Orario limite",
    optionalSuffix = "(facoltativo)",
    submitButton = "Aggiungi consegna",
    saveEditedDeliveryButton = "Salva modifica",
    deliveryCreated = "Consegna aggiunta",
    errorRecipientNameRequired = "Il nome del destinatario è obbligatorio",
    errorRecipientNameTooLong = "Il nome è troppo lungo (max 150 caratteri)",
    errorAddressRequired = "L'indirizzo è obbligatorio",
    errorAddressTooLong = "L'indirizzo è troppo lungo (max 255 caratteri)",
    errorPhoneTooLong = "Il telefono è troppo lungo (max 20 caratteri)",
    errorDuplicateDelivery = "Questa consegna è già nella lista (stesso destinatario e indirizzo)",
    errorRouteNotFound = "Percorso non trovato",
    errorForbidden = "Non sei autorizzato a modificare questo percorso",
    errorValidation = "Controlla i campi inseriti",
    errorGeneric = "Si è verificato un errore. Riprova.",
    errorRouteNotInProgress = "Questo percorso non è più in corso. Impossibile aggiungere una consegna.",
    unknownRecipientLabel = "Sconosciuto",
    driverHomeTitle = "Il mio percorso",
    driverModeBadge = "Modalità autista",
    routeStatusScheduled = "Pianificato",
    routeStatusInProgress = "In corso",
    routeStatusCompleted = "Completato",
    stopsCountLabel = "fermate",
    startRouteButton = "Avvia percorso",
    noRouteTitle = "Nessun percorso",
    noRouteSubtitle = "Al momento non ti è assegnato alcun percorso.",
    noRoutePastSubtitle = "Nessun percorso ti è stato assegnato per questa data.",
    routeInProgressTitle = "Percorso in corso",
    routeCompletedTitle = "Percorso completato",
    deliveriesSectionTitle = "Consegne",
    addStopButton = "Aggiungi una fermata",
    errorConflict = "Il percorso è già stato avviato o completato.",
    greetingPrefix = "Ciao",
    routeOfTheDayLabel = "GIRO DI OGGI",
    noOtherRouteLabel = "Nessun altro giro pianificato",
    routeLabel = "Giro",
    importMenuTitle = "Importa consegne",
    importMenuSubtitle = "Più modalità combinabili — scegli una fonte",
    importModePhotoPaperTitle = "Foto — elenco cartaceo",
    importModePhotoPaperDesc = "Fotografa un foglio manoscritto o stampato",
    importModePhotoLabelTitle = "Foto — etichetta del pacco",
    importModePhotoLabelDesc = "Scansiona l'etichetta attaccata a un pacco",
    importModePdfTitle = "Importa un PDF",
    importModePdfDesc = "Bolle di consegna, file scansionato",
    importModeExcelTitle = "Excel / CSV",
    importModeExcelDesc = "Il tuo formato — colonne rilevate automaticamente",
    importModeManualTitle = "Inserimento manuale",
    importModeManualDesc = "Nome, indirizzo, telefono, ora limite",
    createRouteTitle = "Crea un giro",
    createRouteEmptyDrivers = "Nessun autista nel tuo team per ora",
    editDeliveriesAction = "Modifica",
    moreDeliveriesLabel = "altre",
    addDeliveriesAction = "Aggiungi consegne",
    assignToTitle = "Assegna a",
    optimizeRouteButton = "Ottimizza il percorso",
    createRouteButtonNoOptimize = "Crea il percorso",
    errorNoEnterprise = "Nessuna azienda associata al tuo account",
    errorDriverNotFound = "Autista non trovato",
    errorNoDeliveries = "Aggiungi almeno una consegna prima di ottimizzare il percorso",
    errorOptimizationUnavailable = "Il servizio di ottimizzazione è temporaneamente non disponibile.",
    errorGeocodingFailed = "Impossibile localizzare alcuni indirizzi di consegna. Modifica l'indirizzo e riprova.",
    dispatchTitle = "Ottimizzazione",
    optimizedSuccessTitle = "Percorso ottimizzato!",
    optimizedSuccessSubtitleSuffix = "fermate ordinate per il percorso più breve",
    stopsStatLabel = "Fermate",
    driverAvailableStatus = "Disponibile",
    sendRouteButtonPrefix = "Invia il giro a",
    errorRouteAlreadyDispatched = "Il giro è già stato inviato.",
    stopDetailTitlePrefix = "Fermata",
    stopStatusCurrentLabel = "In corso",
    stopStatusUpcomingLabel = "In arrivo",
    stopStatusDeliveredLabel = "Consegnato",
    stopStatusFailedLabel = "Fallito",
    stopRecipientLabel = "Destinatario",
    callActionLabel = "Chiama",
    noPhoneLabel = "Telefono non indicato",
    packagesCountLabel = "colli",
    navigateButton = "Naviga",
    deadlineBeforePrefix = "Prima delle",
    deadlinePastSuffix = "scaduto",
    validateStopAction = "Convalida questa fermata",
    teamDashboardTitle = "Percorsi",
    todayDateLabel = "Oggi",
    liveBadgeLabel = "In diretta",
    statRoutesLabel = "Percorsi",
    statDeliveriesLabel = "Consegne",
    statCompletedLabel = "Completate",
    teamSectionTitle = "Team",
    routeStartedAtPrefix = "Iniziato alle",
    routeCompletedAtPrefix = "Completato alle",
    routeNotStartedLabel = "Non iniziato",
    emptyTeamRoutesTitle = "Nessun percorso quel giorno",
    emptyTeamRoutesSubtitle = "Nessun autista del team ha un percorso pianificato per questa data.",
    errorInvalidDate = "Data non valida",
    routeDetailTitle = "Dettaglio percorso",
    driverEyebrowLabel = "Autista",
    failedDeliveryTag = "Consegna fallita",
    driverLoadingCheckTitle = "Verifica del carico",
    loadingCheckInstructionText = "Verifica che tutti i pacchi previsti siano caricati nel veicolo prima di partire.",
    expectedPackagesLabel = "pacchi previsti per questo giro",
    confirmLoadCheckboxPrefix = "Ho caricato i",
    confirmLoadCheckboxSuffix = "pacchi previsti per questo giro",
    reportDiscrepancyToggleLabel = "Segnala una discrepanza",
    discrepancyNotePlaceholder = "Es.: ho caricato 9 pacchi invece di 11…",
    discrepancyNoteTooLong = "Nota troppo lunga — massimo 500 caratteri.",
    undeliveredStopsSectionTitle = "Pacchi non presi in carico — rimuovi dal giro",
    removedStopNoticePrefix = "«",
    removedStopNoticeMiddle = "» rimosso dal giro — 1 fermata in meno",
    remainingStopsSuffix = "rimanenti",
    confirmAndStartButton = "Conferma e avvia il giro",
    loadingOnBehalfOfLabel = "Per conto di",
    loadingExpectedLabel = "Carico previsto",
    loadingQuestionTitle = "Hai caricato tutti i pacchi?",
    loadingAllLoadedPrefix = "Sì, i",
    loadingAllLoadedSuffix = "pacchi sono a bordo",
    loadingIncompleteOption = "Carico incompleto",
    loadingIncompleteHint = "Rimuovo le fermate interessate o giustifico",
    loadingIncompleteRemoveLabel = "E/o rimuovi le fermate non caricate",
    slideToStartLabel = "Scorri per iniziare",
    completeRouteButton = "Termina il percorso",
    completeRouteDialogTitle = "Terminare il percorso?",
    completeRouteDialogPendingCountSuffix = "consegne non sono ancora state gestite",
    completeRouteDialogPendingNote = "Verranno contrassegnate come non gestite.",
    completeRouteDialogBody = "Questa azione è definitiva: il percorso passerà allo stato \"Completato\" e non potrà più essere modificato.",
    completeRouteDialogBodyAllTreated = "Tutte le consegne sono state gestite. Il percorso passerà allo stato \"Completato\" e non potrà più essere modificato.",
    completeRouteDialogConfirm = "Termina",
    routeCompletedMessage = "Percorso completato.",
    stopStatusUntreatedLabel = "Non gestita",
    errorCompleteRouteStatusConflict = "Questo percorso non può essere terminato nel suo stato attuale.",
    errorCompleteRoutePendingStopsConflict = "Alcune consegne sono ancora in attesa. Conferma per terminare comunque.",
    ),
    extra = RouteStringsExtraImpl(
    packageCountFieldLabel = "Numero di colli",
    newStopBadgeLabel = "NUOVO",
    reoptimizeResultTitle = "Nuovo percorso",
    reoptimizeSuccessTitle = "Percorso riottimizzato",
    reoptimizeSuccessSubtitleSuffix = "fermata aggiunta e riposizionata per il percorso più breve.",
    reoptimizeFallbackTitle = "Fermata aggiunta, riottimizzazione non disponibile",
    reoptimizeFallbackSubtitle = "Il servizio di ottimizzazione è temporaneamente non disponibile. La nuova fermata è stata aggiunta alla fine dell'elenco.",
    addedStatLabel = "Aggiunta",
    backToRouteButton = "Torna al percorso",
    routeBatchMultiDriverLink = "Suddividi tra più autisti",
    routeBatchSelectTitle = "Suddividi il giro",
    routeBatchDeliveriesReadyLabel = "consegne pronte per la suddivisione",
    routeBatchDriversSectionTitle = "Autisti",
    routeBatchDriversSelectedSuffix = "autisti selezionati",
    routeBatchOptimizeToggleTitle = "Ottimizza l'itinerario",
    routeBatchOptimizeToggleHelp = "RoutaR suddivide e ordina le fermate in base alla distanza. Disattivato: suddivisione equa semplice in base al numero di fermate, senza calcolo del percorso.",
    routeBatchSubmitButtonPrefix = "Suddividi tra",
    routeBatchDriversWord = "autisti",
    routeBatchOptimizationUnavailable = "Servizio di ottimizzazione temporaneamente non disponibile. Il giro non è stato creato — verifica la connessione e riprova, oppure disattiva \"Ottimizza l'itinerario\" per una suddivisione semplice immediata.",
    routeBatchPreviewTitle = "Anteprima della suddivisione",
    routeBatchPreviewEyebrowMiddle = "consegne suddivise tra",
    routeBatchPreviewEyebrowSuffix = "autisti",
    routeBatchStopsChipSuffix = "fermate",
    routeBatchDistanceLabel = "Distanza",
    routeBatchDurationLabel = "Durata stimata",
    routeBatchDistanceNotCalculated = "Non calcolata",
    routeBatchOptimizeDisabledBanner = "Ottimizzazione disattivata: suddivisione equa per numero di fermate, senza calcolo di distanza o ordine.",
    routeBatchReoptimizeButton = "Ri-ottimizza",
    routeBatchDispatchButton = "Conferma e invia",
    errorRouteBatchAlreadyDispatched = "Questo lotto è già stato inviato agli autisti — non può più essere modificato.",
    routeBatchDispatchedTitle = "Giri inviati!",
    routeBatchDispatchedSubtitleSuffix = "autisti avvisati simultaneamente, ciascuno con il proprio giro programmato.",
    routeBatchStatRoutesLabel = "Giri",
    routeBatchStatDeliveriesLabel = "Consegne",
    routeBatchStatusLabel = "Stato",
    routeBatchStatusDispatchedValue = "Inviato",
    routeBatchSentAtLabel = "Inviato il",
    routeBatchPerDriverTitle = "Dettaglio per autista",
    routeBatchDriverScheduledStatus = "Programmato",
    routeBatchBackToHomeButton = "Torna alla home",
    errorTooManyDrivers = "Non puoi selezionare più di 50 autisti alla volta.",
    errorTooManyDeliveries = "Un lotto non può superare le 500 consegne.",
    createRouteFabLabel = "Nuovo giro",
    createOwnRouteButtonLabel = "Crea / ottimizza il mio giro",
    createOwnRouteTitle = "Crea il mio giro",
    createOwnRouteDeliveriesCountSuffix = "consegne pronte",
    stopStatusEnRouteLabel = "In viaggio",
    yesterdayDateLabel = "Ieri",
    periodPastLabel = "Passate",
    periodTomorrowLabel = "Domani",
    viewRouteButton = "Vedi il percorso",
    viewButton = "Vedi",
    noRouteTomorrowTitle = "Niente in programma per domani",
    noRouteTomorrowSubtitle = "Pianifica un percorso in anticipo per averlo pronto già domani mattina.",
    planRouteButtonLabel = "Pianifica un percorso",
    myRoutesTodayTitle = "I tuoi percorsi di oggi",
    myRoutesTitle = "I tuoi percorsi",
    weekdayShortNames = listOf("Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"),
    weekdayFullNames = listOf("Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato", "Domenica"),
    monthNames = listOf("gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"),
    statRoutesTodayLabel = "Percorsi oggi",
    statStopsTodayLabel = "Fermate oggi",
    statOnTimeLabel = "In orario oggi",
    statAvgProgressLabel = "Avanzamento medio",
    inProgressSectionTitle = "In corso",
    upcomingSectionTitle = "In arrivo",
    doneSectionTitle = "Completati",
    seeAllLabel = "Vedi tutti",
    continueRouteButton = "Continua il percorso",
    detailsLinkLabel = "Dettagli",
    deliveryProofTitle = "Convalida la consegna",
    deliveryProofStatusSectionLabel = "Stato della consegna",
    deliveryProofPhotoSectionLabel = "Foto giustificativa",
    deliveryProofPhotoHint = "Obbligatoria per convalidare",
    deliveryProofTakePhotoCta = "Scatta una foto",
    deliveryProofRetakePhotoCta = "Rifai la foto",
    deliveryProofRetakeChipLabel = "Rifai",
    deliveryProofCommentSectionLabel = "Commento",
    deliveryProofCommentRequiredSuffix = "obbligatorio in caso di esito negativo",
    deliveryProofCommentPlaceholderOptional = "Facoltativo — dettagli sulla consegna…",
    deliveryProofCommentPlaceholderRequired = "Spiega il motivo dell'esito negativo…",
    deliveryProofCommentRequiredError = "È richiesto un commento in caso di consegna non riuscita",
    deliveryProofSubmitButton = "Convalida la consegna",
    deliveryProofErrorInvalidPhoto = "Foto illeggibile o formato non supportato. Rifai la foto e riprova.",
    deliveryProofAlreadyProcessedBanner = "Questa fermata è già stata gestita e non può più essere modificata.",
    deliveryConfirmTitle = "Consegna convalidata",
    deliveryConfirmSuccessTitle = "Consegna confermata",
    deliveryConfirmSuccessSubtitle = "La prova è stata registrata per questa fermata.",
    deliveryConfirmFailedTitle = "Esito negativo registrato",
    deliveryConfirmFailedSubtitle = "Il commento e la foto sono stati inviati al gestore.",
    deliveryConfirmRouteCompletedTitle = "Percorso completato!",
    deliveryConfirmRouteCompletedSubtitle = "Tutte le fermate sono state gestite.",
    deliveryConfirmValidatedAtLabel = "Convalidato il",
    deliveryConfirmNextStopEyebrowPrefix = "Fermata successiva",
    deliveryConfirmGoToNextStopButton = "Vai alla fermata successiva",
    deliveryConfirmAllDoneMessage = "Questa era l'ultima fermata del percorso — ricordati di chiuderlo.",
    offlineBannerTitle = "Offline",
    offlineBannerRouteSubtitle = "le tue convalide verranno inviate non appena torna la rete",
    offlineBannerValidateSubtitle = "verrà salvata localmente",
    offlineSyncingBannerTitle = "Sincronizzazione in corso",
    offlineSyncingSubtitleSuffix = "consegne inviate",
    offlineRetryBannerTitle = "Sincronizzazione non riuscita",
    offlineRetryBannerSubtitle = "nuovo tentativo alla prossima connessione di rete",
    offlineSyncSuccessToastSuffix = "consegne sincronizzate con successo",
    offlineQueuedBadgePendingLabel = "In attesa di invio",
    offlineQueuedBadgeSyncingLabel = "Invio in corso",
    offlineQueuedBadgeFailedLabel = "Non riuscito — nuovo tentativo previsto",
    offlineQueuedBadgeConflictLabel = "Già gestito altrove",
    offlineDismissConflictAction = "Ignora",
    offlineValidatedLocallyAtPrefix = "convalidato localmente alle",
    offlineAddStopRequiresConnectionSuffix = "(richiede una connessione)",
    deliveryProofOfflineSubmitButton = "Salva (sincronizzazione differita)",
    deliveryProofSavedLocallyTitle = "Salvato localmente",
    deliveryProofSavedLocallySubtitle = "Questa consegna verrà inviata automaticamente non appena la connessione sarà ripristinata.",
    routeScheduledBannerTitle = "Percorso non ancora avviato",
    routeScheduledBannerSubtitle = "Avvia il percorso per poter convalidare una consegna.",
    geocodeIssueTag = "Indirizzo non localizzato",
    regeocodeAction = "Riprova la geolocalizzazione",
    regeocodeSuccessMessage = "Indirizzi aggiornati",
    dashboardTitle = "Dashboard",
    viewAllAction = "Vedi tutti",
    deleteRouteDialogTitle = "Eliminare il percorso?",
    deleteRouteDialogMessage = "Questo percorso verrà eliminato definitivamente. Questa azione è irreversibile.",
    errorRouteDeleteConflict = "Eliminazione non disponibile: il percorso è in corso.",
    errorDriverHasActiveRoute = "Un altro percorso è attualmente in corso. Terminalo prima di avviare questo.",
    dashboardLiveBadge = "Live",
    routeBatchNoStopsTag = "Nessuna fermata",
    routeBatchNoStopsDialogTitle = "Autista senza fermate",
    routeBatchNoStopsDialogMessage = "Almeno un autista non ha alcuna fermata assegnata. Riceverà comunque un percorso vuoto se non viene rimosso da questo lotto. Inviare comunque?",
    ),
)
